import React, { useContext } from 'react'
import { ValidateAllWrapper } from './styles'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { CORRECT_FORMALITY_QUESTION_MUTATION } from 'graphql/LegalFormalities'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { validateEmpties } from './FormHelpers'
import { AbilityContext } from '../../../../../../contexts/abilityContext'

interface IProps {
  nameKeys: string[]
}

const ValidateAll = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { nameKeys } = props
  const [saveCorrection] = useMutation(CORRECT_FORMALITY_QUESTION_MUTATION)
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const ability: any = useContext(AbilityContext)
  const formalistOnly = ability.can('update', 'LegalFormality')

  if (!formalistOnly) return <></>

  return (
    <ValidateAllWrapper>
      <button
        onClick={() =>
          validateEmpties(legalFormality, saveCorrection, nameKeys)
        }
      >
        {t('form.btns.validateAll')}
      </button>
    </ValidateAllWrapper>
  )
}

export default ValidateAll
